import { render, staticRenderFns } from "./MatterTradeFairForm.vue?vue&type=template&id=2570370c&"
import script from "./MatterTradeFairForm.vue?vue&type=script&lang=js&"
export * from "./MatterTradeFairForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterTradeFairForm.vue?vue&type=style&index=0&id=2570370c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports